<mat-sidenav-container class="sidenav-container" fxFlexFill>
  <mat-sidenav #sidenav mode="over">

    <div class="sidenav-header">
      <img alt="img" id="img-menu-back" (click)="sidenav.toggle()" src="assets/icons/menu_back.png">

      <div style="bottom: 10px; position: absolute; margin-left: 20px;">
        <span id="menu-title" fxLayoutAlign="start end">{{displayName}}</span>
        <span id="menu-sub-title" fxLayoutAlign="start end">{{userEmail}}</span>

      </div>
    </div>

    <div class="div-scroll-sidenav" [ngClass.xs]="cssclass">
      <mat-list id="mat-list-container">
        <mat-list-item *ngFor="let item of navItems" matRipple [matRippleColor]="rippleColor"
          (click)="listItemClick(item.title)">
          <div id="div-list-item" fxLayoutGap="10px">
            <img alt="img" id="list-logo" src={{item.icon}}>
            <p dir="auto" class="p-nav-items" mat-line>{{ item.title | transloco}} </p>
          </div>
        </mat-list-item>
      </mat-list>
      <div class="divider" *ngIf="travelItems.length > 0"></div>
      <mat-list id="mat-list-container" >
        <mat-list-item *ngFor="let item of travelItems" matRipple [matRippleColor]="rippleColor"
          (click)="listItemClick(item.title)">
          <div id="div-list-item" fxLayoutGap="10px">
            <img alt="img" id="list-logo" src={{item.icon}}>
            <p dir="auto" class="p-nav-items" mat-line>{{item.title | transloco}} </p>
          </div>
        </mat-list-item>
        <div class="divider"></div>
        <mat-list-item *ngFor="let item of fixednavItems" matRipple [matRippleColor]="rippleColor"
          (click)="listItemClick(item.title)">
          <div id="div-list-item" fxLayoutGap="10px">
            <img alt="img" id="list-logo" src={{item.icon}}>
            <p dir="auto" class="p-nav-items" mat-line>{{item.title | transloco}} </p>
          </div>
        </mat-list-item>
        <div class="divider"></div>
        <mat-list-item matRipple [matRippleColor]="rippleColor" (click)="listItemClick('Logout')">
          <div id="div-list-item" fxLayoutGap="10px">
            <img alt="img" id="list-logo" src="assets/icons/logout.svg">
            <p class="p-nav-items" mat-line>{{'logout' | transloco}}</p>
          </div>
        </mat-list-item>

      </mat-list>

    </div>

    <div id="div-version" fxLayout="column" fxLayoutGap="0px" fxLayoutGap.xs="0px">
      <!-- <span fxLayout="column" fxLayoutAlign="center center">
        <span class="powered-by regular">{{'powered_by' | transloco}}</span>
        <img alt="img" src="assets/images/DPS logo.svg" />
      </span>
      <p id="p-version">v1.9.0 </p> -->
    </div>
  </mat-sidenav>
  <mat-sidenav-content fxFlexFill fxLayout="column" ngClass="background app">
    <div fxFlex fxLayout="column" class="background app normal" ngClass.xs="background app xs">

      <!-- Start of Toobar -->
      <app-toolbar (sidenavToggle)="sidenav.toggle()" [ngClass]="{'fixed':!onDashboard}">

      </app-toolbar>
      <!-- End of Toobar -->

      <!--Start Content-->
      <div fxFlex *ngIf="!isOffline" [ngClass]="{'content-transparent':onDashboard,'content':!onDashboard}"
        [ngClass.xs]="{'content-transparent':onDashboard,'content xs':!onDashboard}">
        <ng-content></ng-content>
      </div>
      <div *ngIf="isOffline" [ngClass]="{'content-transparent':onDashboard,'content':!onDashboard}">
        <app-no-internet></app-no-internet>
      </div>
      <!--End Content-->

      <!-- Start of Footer -->
      <div  fxLayoutAlign="center center" *ngIf="showInternal && !isOffline" ngClass="background footer normal"
        ngClass.xs="background footer xs">
          <h2 class="footer-fns">Safe Today, Safer Tomorrow</h2>
      </div>
      <!-- End of Footer -->

    </div>
    <footer>

    </footer>
  </mat-sidenav-content>
</mat-sidenav-container>
